<template>
  <div class="container">
    <div class="top-panel">
      <div class="order-title">
        我的订单
      </div>

      <div class="payment-choose-container">
        <div class="payment-choose">
          <div class="payment" :class="{ active: isActive(99)}" @click="switchList(99)">全部</div>
          <div class="payment" :class="{ active: isActive(8)}" @click="switchList(8)">待付款</div>
          <div class="payment" :class="{ active: isActive(1)}" @click="switchList(1)">待服务</div>
          <div class="payment" :class="{ active: isActive(9)}" @click="switchList(9)">已完成</div>
        </div>
      </div>
    </div>
    <div v-if="!isEmpty">
        <div class="weui-cells">
          <a class="weui-cell weui-cell_access" href="javascript:;" @click="goOrder(item)" v-for="item in orderList">
              <div class="weui-cell__bd">
                  <p>{{item.type_name}} <span class="color-grey">{{item.order_id}}</span><br> <span class="orderDate">服务时间：{{item.service_date}}</span>
                  </p>
              </div>

              <div class="weui-cell__ft" v-if="item.lifecycle_status==1">
                <span>{{item.lifecycle_text}}</span>
              </div>

              <div class="weui-cell__ft" v-else-if="item.order_status==8">
                <span>{{item.order_status_name}}</span>
              </div>

              <div class="weui-cell__ft" v-else>
                <span :class="{ unpaid: isUnpaid(item.pay_status)}">{{item.pay_status_name}}</span>
              </div>
          </a>
      </div>
    </div>

    <div class="empty" v-show="isEmpty">
      <img src="../../assets/img/order/empty.svg">
      <br>
	  <div v-if="checkLogin()">
	  		欢迎使用到家<br>
	  		<router-link to="/" class="color-orange">立即下单</router-link>，体验我们的服务吧
	  </div>
	  <div v-else="checkLogin()">
	      <router-link to="/login"><a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_daojia">登录查看订单</a></router-link>
	      <br>
	      若您是刚下完单的新用户，请查收短信获取账号和密码信息
	  </div>

    </div>

    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在获取订单</p>
            </div>
        </div>
    </transition>

  </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order',
  data () {
    return {
      isSending:false,
      payFilter:99,
      listObject:{},
      orderList:{},
      isEmpty:false,
      orderDetail:{
        data:{
          move_scale: "",
          move_valuables: [],
          move_car: "",
          move_out_name: "",
          move_out_phone: "",
          move_out_street: "",
          move_out_suburb: "",
          move_out_state: "",
          move_out_postcode: "",
          move_out_floor: "",
          move_out_parking: "",
          move_in_name: "",
          move_in_phone: "",
          move_in_street: "",
          move_in_suburb: "",
          move_in_state: "",
          move_in_postcode: "",
          move_in_floor: "",
          move_in_parking: "",
          service_date: "",
          service_period: "",
          move_other_valuables: "",
          agency: ""
        },
      }
    }
  },
  methods: {
    switchList(val){
      this.payFilter = val;
      if(this.checkLogin()){
        this.getList(val);
      }
    },
    goOrder(item){
      if(item.lifecycle_status==1){
        this.$router.push('/order-cancel?reason=timeout');
        return false;
      }
      this.goto('/order-detail?id='+item.order_number+'&type='+item.type_id);
    },
    convPay(val){
      let result = '';
      switch (val) {
        case '0':
          result = '待付定金'
          break;
        case '1':
          result = '已付定金，等待服务'
          break;
        case '2':
          result = '服务完毕，待付余款'
          break;
        case '3':
          result = '订单已完成'
          break;
        default:
          console.log("Sorry, we are out of service.");
      }
      return result;
    },
    isActive(val) {
      if(this.payFilter==val){
        return true;
      }
      else{
        return false;
      }
    },
    isUnpaid(val) {
      if(val=="0" || val=="2" ){
        return true;
      }
      else{
        return false;
      }
    },
    getList(val){
      if(this.isSending){
        return false;
      }
      else{
        let listObject={};
        let that = this;
        this.isSending = true;
        listObject.pay_status = val;
        if(val==99){
          listObject.pay_status = '';
          listObject.filter_status = 0;
        }
        else{
          listObject.filter_status = 1;
        }
        listObject.token = localStorage.token;
        listObject.per_page = 300;
        listObject.page = 1;

        this.axios.post(this.apiURL()+'/Order/orderList', qs.stringify(listObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isEmpty=false;
            that.isSending = false;
            that.orderList = response.data.data;
            window.scrollTo(0,0);
          }
          else{
            that.isEmpty=true;
            that.isSending=false;
          }
        })
        .catch(function (error) {
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.orderDetail.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("Sorry, we are out of service.");
      }
      return result;
    }
  },
  created: function () {
  },
  mounted: function () {
    if(this.checkLogin()){
      this.profileValidate();
      this.getList(99);
    }
    else{
      this.isEmpty=true;
    }

    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
  padding-top:100px;
}

.color-grey{
  color:#999;
}

.top-panel{
  position:fixed;
  left:0;
  top:0;
  width:100%;
  z-index:99;
}

.order-title{
  font-size:2em;
  color: #595D68;
  font-size: 20px;
  font-weight: bold;
  background:#fff;
  text-align:center;
  padding-top:1em;
}

.payment-choose, .payment-choose-container{
  background:#fff;
}

.order-title-sub{
  padding:0 0 0 15px;
  color: #666;
  font-size: 16px;
  margin-bottom:2em;
}

.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:6vh;
  color:#999;
}

.container /deep/{
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 70%;
    font-size: 0.9em;
  }

  .weui-cells__title{
    font-size:16px;
  }
}

.payment-choose{
  border-bottom:1px solid #eee;
  width:100%;
  margin:0 auto 0 auto;
  display: flex;
  justify-content:space-evenly;
  .payment{
    padding:1em 0.2em 0 0.2em;
  }
  .payment.active{
    color:#fe9567;
    border-bottom: solid 3px #fe9567;
    padding-bottom:0.6em;
  }
}

.unpaid{
  color:#fe9567;
}

.orderDate{
  color:#999;
  font-size:0.8em;
}

.weui-btn_daojia{
	padding:2px 16px;
	font-size:1em;
	margin:14px 0;
	color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-list.vue